import AES from 'crypto-js/aes'
import encUtf8 from 'crypto-js/enc-utf8'

const SECRET = process.env.REACT_APP_STORAGE_SECRET ?? 'pcrm-fallback-secret'

export const encrypt = (plain: string): string => {
  if (!plain) return ''
  return AES.encrypt(plain, SECRET).toString()
}

export const decrypt = (cipher: string): string => {
  if (!cipher) return ''
  try {
    const bytes = AES.decrypt(cipher, SECRET)
    return bytes.toString(encUtf8)
  } catch {
    return ''
  }
}

export const setSecureItem = (key: string, value: string): void => {
  localStorage.setItem(key, encrypt(value))
}

export const getSecureItem = (key: string): string | null => {
  const raw = localStorage.getItem(key)
  if (raw === null) return null
  const plain = decrypt(raw)
  return plain || null
}

export const removeSecureItem = (key: string): void => {
  localStorage.removeItem(key)
}
